<template>
  <div>
    <button class="btn " :class="getClass(this.value)" @click="enable()" >是</button>

    <button class="btn " :class="getClass(!this.value)" @click="disable()" >否</button>

    {{this.value}}
  </div>
</template>

<script>
/**
 <MyButtonYesNo v-model="item.IsEnable"></MyButtonYesNo>
 **/


export default {
  // name: "MyColorPicker",
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      propsValue:this.value,
    };
  },
  watch: {
    propsValue(newVal){
      this.$emit('input', newVal);
    },
    value(newVal){
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    disable(){
      this.value=false;
    },
    enable(){
      this.value=true;
    },
    getClass(value){
      if (value){
        return "btn-primary";
      } else{
        return "btn-outline-secondary";
      }
    },
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
